<ng-container *ngrxLet="otp$; let otp">
  @if (!identifier && otp) {
    <missing-identifier-info
        [otp]="otp"
        infoTranslationKey="errors.login.missing_identifier"/>
  } @else {
    @if (hasError || !otp) {
      <p class="login-confirmation-error">
        {{ 'errors.login.email_otp' | translate }}</p>
    }
  }
</ng-container>
